import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://2780da01181e0091d37062786a593a34@o4511246005633024.ingest.us.sentry.io/4511296270434304",

  // Environment tag — set REACT_APP_SENTRY_ENVIRONMENT in production env
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || "production",

  // Release tag — populated by CI in a future step
  release: process.env.REACT_APP_SENTRY_RELEASE || undefined,

  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
      // Don't try to clone fetch response bodies — axios/React Query consumes the stream
      // first, causing "Failed to clone response body" errors. We still capture network
      // metadata (URL, status, headers), just not bodies.
      networkDetailAllowUrls: [],
      networkCaptureBodies: false,
    }),
  ],

  // Performance sampling — 10% of transactions
  tracesSampleRate: 0.1,

  // Session Replay — never record routine sessions, always record on error
  replaysSessionSampleRate: 0.0,
  replaysOnErrorSampleRate: 1.0,

  // Send IP/user-agent for debugging context
  sendDefaultPii: true,

  // Always enabled in production. Set REACT_APP_SENTRY_DISABLE=true at build time
  // if you ever need to turn Sentry off without removing the code.
  enabled: process.env.REACT_APP_SENTRY_DISABLE !== "true",
});
